import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable max-len, react/prop-types */
var PinMap = function PinMap() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    height: "44",
    role: "presentation",
    viewBox: "13.8 0.02 62.48 89.98",
    width: "44",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Outdoor Voices Map Pin Marker Icon"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#000F9F",
      d: "M72.7 16.8c-5.8-11.2-18-18-31-16.6C35.6.8 30.1 3.1 25.4 7c-7 5.7-10.8 13-11.5 22-.4 5.3.4 10.5 2.8 15.3 1.5 3 3.2 5.8 5 8.6 6.2 9.9 12.4 19.8 18.6 29.6 1.5 2.5 3.2 4.9 4.8 7.5.4-.6.7-1.1 1-1.5 8.4-13.4 16.7-26.7 25.1-40.1 2.8-4.4 4.6-9.1 5-14.3.4-6.1-.7-11.9-3.5-17.3ZM44.9 50.5c-10.5 0-19.2-8.7-19.2-19.3C25.7 20.6 34.4 12 45 12c10.7 0 19.3 8.6 19.3 19.3 0 10.6-8.7 19.2-19.4 19.2Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFFFFF",
      d: "M64.3 31.2c0 10.6-8.7 19.3-19.4 19.3-10.5 0-19.2-8.7-19.2-19.3C25.7 20.6 34.4 12 45 12c10.6 0 19.3 8.6 19.3 19.2Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#000F9F",
      d: "M39 24.7c3.6 0 6.6 2.9 6.6 6.6 0 3.7-2.9 6.6-6.6 6.6-3.6 0-6.6-2.9-6.6-6.6 0-3.7 2.9-6.6 6.6-6.6ZM39 36c2.6 0 4.8-2.1 4.8-4.8 0-2.6-2.1-4.8-4.8-4.8-2.6 0-4.8 2.1-4.8 4.8 0 2.7 2.1 4.8 4.8 4.8ZM57.6 24.9l-5 12.7h-2.4l-5-12.7h2.1l4.1 10.6h.1l4.1-10.6h2Z"
    })]
  });
};

export default PinMap;